import React from 'react'
import TermsBig from './SpecificDevice/Big/T&Cs'
export default function Terms() {
    return (
        <div>
            <TermsBig/>
        </div>
    )
}